import DropinSupervisorBase from "../dropin-supervisor-base";

/**
 * Base class for all services

   * @category Services

 * @description
 * Services are meant to act sort of like "plugins" for Dropin Supervisor.
 * They plug into the supervisors lifecycles, and the supervisor has a system for easily
 * searching/loading them.
 */
export class ServiceBase {
  protected _name = "ServiceName";
  protected _supervisor: DropinSupervisorBase;

  public get name(): string {
    return this._name;
  }

  public setSupervisor(supervisor: DropinSupervisorBase) {
    this._supervisor = supervisor;
  }

  // this is where we set up any loading stuff
  public registerLoadPromises() {}
}

export default ServiceBase;
